import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initAnalytics, trackPageview } from "../lib/analytics";
import { applyPageMeta } from "../lib/pageMeta";

// Keeps the browser tab, link-preview tags, and (when enabled) the page view
// in step with client-side navigations. The first HTML response is filled in
// by the server for crawlers that do not run this code.
export function RouteEffects() {
  const { pathname } = useLocation();
  useEffect(() => {
    try {
      applyPageMeta(pathname);
      initAnalytics();
      trackPageview(pathname);
    } catch {
      // Meta and analytics run on every navigation. A throw here unmounts
      // the whole tree, because nothing above this effect catches it.
    }
  }, [pathname]);
  return null;
}
